import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';
import { Box } from '@mui/system';
import ProfileContext from '../../context/ProfileContext';
import StaffContext from '../../context/StaffContext';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Route, Routes, useNavigate,Navigate } from 'react-router-dom';
import RequireAuth from '../../components/RequireAuth';
import useAuth from '../../hooks/useAuth';
import Part_Time from './Part_Time';
import Extension from'./Extension'
import StaffOverload from './StaffOverload'
import Overload from './Overload'
import PartTimeAgreement from './PartTimeAgreement'
import ExtensionAgreement from './ExtensionAgreement';
export default function Agreements() {
  const navigate=useNavigate();
  const InfoWrapper=styled(Box)({
    width:'100%',
    marginLeft:'10px',
    display:'flex',
    flexDirection:'column',
    gap:'10px',

  })
  const {state}=useContext(ProfileContext);
  const details=state.details
  const HandleChange = (event, newValue) => {
      setTable(newValue);
      navigate(newValue);
    };
  const {user}=useAuth();
  const roles=user?.roles;
//   if(window.location.pathname==='/staff_agreements')
//   {
//     navigate(roles.includes(106)?"/staff_agreements/staff_overload":"/staff_agreements/part_time")
//   };
   const [table,setTable]=useState(window.location.pathname)

  return (
    <>
    <InfoWrapper>
      <Tabs
          value={table}
          onChange={HandleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
              fontFamily: 'Poppins',
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "18px",
              margin:"10px"
          }}
        >
         {roles?.includes(106) && <Tab value="/staff_agreements" label="Overload" />}
          {roles?.includes(108) &&  <Tab value="/staff_agreements/part_time" label="Part-time" />}
         {roles?.includes(110) &&  <Tab value="/staff_agreements/extensions" label="Extension" />}
        </Tabs>
        <Routes>
        <Route element={<RequireAuth allowedRoles={[106]} />}>
          <Route exact index element={<StaffOverload />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[107]} />}>
          <Route
            exact
            path="/agreement"
            element={<Overload />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[108]} />}>
          <Route exact path="/part_time" element={<Part_Time />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[109]} />}>
          <Route
            exact
            path="/part_time/agreement"
            element={<PartTimeAgreement />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[110]} />}>
          <Route exact path="/extensions" element={<Extension />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[111]} />}>
          <Route
            exact
            path="/extensions/agreement"
            element={<ExtensionAgreement />}
          />
        </Route>
    </Routes>
    </InfoWrapper>
  
    
    </>
  )
}
